export const BRAND = {
  SHORT_NAME: 'CC',
  LONG_NAME: 'Crystal Canine',
  SUPER_SHORT_NAME: 'cc',
};
